import { http } from '../../../../api/http';
import type { Cotizacion, CotizacionCreateRequest } from '../types/cotizacion.types';

export class CotizacionService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/cotizacion',
  };

  public static async getAll(): Promise<Cotizacion[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching cotizaciones:', error);
      throw error;
    }
  }

  public static async getById(id: number): Promise<Cotizacion> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching cotizacion:', error);
      throw error;
    }
  }

  public static async save(data: CotizacionCreateRequest): Promise<Cotizacion> {
    try {
      const response = await http.post(this.ENDPOINTS.BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error saving cotizacion:', error);
      throw error;
    }
  }

  public static async update(id: number, data: CotizacionCreateRequest): Promise<Cotizacion> {
    try {
      const response = await http.put(`${this.ENDPOINTS.BASE}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating cotizacion:', error);
      throw error;
    }
  }

  public static async delete(id: number): Promise<boolean> {
    try {
      await http.delete(`${this.ENDPOINTS.BASE}/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting cotizacion:', error);
      throw error;
    }
  }

  public static async convertirAVenta(id: number): Promise<any> {
    try {
      const response = await http.post(`${this.ENDPOINTS.BASE}/convertir/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error convirtiendo cotizacion:', error);
      throw error;
    }
  }
}
